import { render } from "./YahooSection.vue?vue&type=template&id=76d17648&scoped=true"
import script from "./YahooSection.vue?vue&type=script&lang=js"
export * from "./YahooSection.vue?vue&type=script&lang=js"

import "./YahooSection.vue?vue&type=style&index=0&id=76d17648&scoped=true&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d17648"]])

export default __exports__